// extracted by mini-css-extract-plugin
module.exports = {"chatBoxTop":"ChatContain_chatBoxTop__jnHcl","bottom":"ChatContain_bottom__1CbLu","chatBox":"ChatContain_chatBox__3AQo2","chatBoxWrapper":"ChatContain_chatBoxWrapper__39J2q"};